export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/feature-logistics.83a62313-c27bc0.svg";